const SubmissionsIcon = ({
  width = 19,
  height = 19,
  color = "currentColor",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 19 19'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15.0417 2.375H3.95833C3.08388 2.375 2.375 3.08388 2.375 3.95833V15.0417C2.375 15.9161 3.08388 16.625 3.95833 16.625H15.0417C15.9161 16.625 16.625 15.9161 16.625 15.0417V3.95833C16.625 3.08388 15.9161 2.375 15.0417 2.375Z'
      stroke={color}
      strokeWidth='1.6'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M2.375 7.12533C2.375 6.7054 2.54181 6.30267 2.83875 6.00574C3.13568 5.70881 3.53841 5.54199 3.95833 5.54199H15.0417C15.4616 5.54199 15.8643 5.70881 16.1613 6.00574C16.4582 6.30267 16.625 6.7054 16.625 7.12533'
      stroke={color}
      strokeWidth='1.6'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M2.375 8.70801H4.75C5.38333 8.70801 6.01667 8.94551 6.4125 9.42051L7.28333 10.133C8.55 11.3997 10.5292 11.3997 11.7958 10.133L12.6667 9.42051C13.0625 9.02467 13.6958 8.70801 14.3292 8.70801H16.625'
      stroke={color}
      strokeWidth='1.6'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default SubmissionsIcon;
